import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ComputerIcon from '@mui/icons-material/Computer';
import { useTranslation } from 'react-i18next';

type MoreOptionsProps = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onLocalDeviceClick: () => void;
  onDocumentsClick: () => void;
};

export function MoreOptions({
  anchorEl,
  onClose,
  onLocalDeviceClick,
  onDocumentsClick,
}: MoreOptionsProps): JSX.Element {
  const { t } = useTranslation('providerRoom');
  const open = Boolean(anchorEl);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{
        paper: {
          sx: {
            mt: '-8px',
            borderRadius: '0.5rem',
            background: 'var(--app-surface)',
            boxShadow: 3,
            '& .MuiMenuItem-root': {
              color: 'var(--app-text-default)',
              fontSize: '1.5rem',
              fontWeight: 400,
              gap: '2px',
              px: 2.5,
              py: 1,
            },
            '& .MuiMenuItem-root:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.08)',
            },
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          onLocalDeviceClick();
          onClose();
        }}
      >
        <ListItemIcon sx={{ minWidth: 'auto !important', color: 'var(--app-brand-primary)' }}>
          <ComputerIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText primary={t('localDevice')} primaryTypographyProps={{ variant: 'body1' }} />
      </MenuItem>

      <MenuItem
        onClick={() => {
          onDocumentsClick();
          onClose();
        }}
      >
        <ListItemIcon sx={{ minWidth: 'auto !important', color: 'var(--app-brand-primary)' }}>
          <InsertDriveFileIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText primary={t('documents')} primaryTypographyProps={{ variant: 'body1' }} />
      </MenuItem>
    </Menu>
  );
}
